import { ADD_PENDING_REQUEST, CLEAR_PENDING_REQUESTS } from './actionTypes';

const defaultState = {
  pendingRequests: [],
};

export function requestCancellation (state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case ADD_PENDING_REQUEST:
      return { ...state, pendingRequests: [...state.pendingRequests, payload] };

    case CLEAR_PENDING_REQUESTS:
      return { ...state, pendingRequests: [] };

    default:
      return state;
  }
}
